import React from 'react';
import * as Styled from './SimpleTab.styles';
import { CustomIcon } from '../../../components/CustomIcon';
import { IconType } from '../../CustomIcon/CustomIcon.config';
import { Typography } from '../../Typography';

export enum Sizes {
  small = 'small',
  default = 'default',
}

export interface FilterDataValues {
  active?: boolean;
  count?: number;
  label: string;
}

export type Filter = {
  active?: boolean;
  count?: number;
  field: string;
  id: string;
  label: string;
  parent?: string;
  value?: any;
  values?: FilterDataValues[];
  parentsLabel?: string;
  high?: number;
  low?: number;
  visible?: boolean;
};

export type SimpleTabType = {
  id?: string;
  title: string;
  selected?: boolean;
  counter?: number | string;
  filter?: Filter;
  disabled?: boolean;
};

type Props = {
  size?: Sizes;
  leftIconName?: IconType;
  onTabClick?: (value?: Filter) => void;
} & SimpleTabType;

const SimpleTab: React.FC<Props> = React.memo(
  ({
    title,
    disabled,
    selected,
    filter,
    onTabClick,
    size = Sizes.default,
    counter,
    leftIconName,
  }) => {
    const handleClick = () => {
      onTabClick?.(filter);
    };

    return (
      <Styled.ProjectItem
        disabled={disabled}
        selected={selected}
        size={size}
        onClick={handleClick}
      >
        {leftIconName != null ? (
          <CustomIcon name={leftIconName} dense wrapperClassName="tabIcon" />
        ) : null}
        <Typography
          variant={size === Sizes.default ? 'body' : 'tiny'}
          className="title"
        >
          {title}
        </Typography>
        {counter != null ? <div className="badge">{counter}</div> : null}
      </Styled.ProjectItem>
    );
  },
);

SimpleTab.displayName = 'SimpleTab';

export default SimpleTab;
